import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from './apiAuth';
import { authHeader, userEmail, canonicalizeResponse } from './common';
import { notification } from 'antd';
// Async Thunk
export const submitReferData = createAsyncThunk(
  "refer/submitReferData",
  async ( referData , { rejectWithValue }) => {
 
    try {
   
      const response = await api.post('/referrals/apply', referData, {
        headers: await authHeader(),
      });
      notification.success({
        message: response.data.message,
      });
   console.log("this api success")
      return canonicalizeResponse(response);
    } catch (error) {
      console.log("api error",error)
      notification.error({
        message: error?.response?.data?.message,
      });
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const listReferrals = createAsyncThunk(
  "refer/listReferrals",
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get('/referrals', {
        headers: await authHeader(),
        params: params
      }); 
      return canonicalizeResponse(response);
    } catch (error) {
      notification.error({
        message: error?.response?.data?.message || "Failed to fetch referral data",
      });
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const getReferralEarning = createAsyncThunk(
  "refer/getReferralEarning",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/api/referral/earning', {
        headers: await authHeader(),
      });
      return canonicalizeResponse(response);
    } catch (error) {
      notification.error({
        message: error?.response?.data?.message || "Failed to fetch referral earnings",
      });
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// Share Referral via Email
export const shareReferral = createAsyncThunk(
  "refer/shareReferral",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post('/referrals/share', payload, {
        headers: await authHeader(),
      });
      notification.success({
        message: response.data.message || "Referral invitation sent successfully!",
      });
      return canonicalizeResponse(response);
    } catch (error) {
      notification.error({
        message: error?.response?.data?.message || "Failed to send referral invitation",
      });
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// Initial State
const initialState = {
  referCode: "",
  referralList: [],
  referralEarning: null,
  error: null,
  submittingReferData: false,
  submittingReferDataError: null,
  listingReferData: false,
  listingReferDataError: null,
  fetchingEarning: false,
  fetchingEarningError: null,
  sharingReferral: false,
  sharingReferralError: null,
};

// Slice
const referralSlice = createSlice({
  name: "refer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitReferData.pending, (state) => {
        state.submittingReferData = true;
        state.submittingReferDataError = null;
      })
      .addCase(submitReferData.fulfilled, (state, action) => {
        state.referCode = "";
        state.submittingReferData = false;
      })
      .addCase(submitReferData.rejected, (state, action) => {
        state.submittingReferData = false;
        state.submittingReferDataError = action.payload;
      })
      .addCase(listReferrals.pending, (state) => {
        state.listingReferData = true;
        state.listingReferDataError = null;
      })
      .addCase(listReferrals.fulfilled, (state, action) => {
        state.referralList = action.payload;
        console.log("list referrals", action.payload);
        state.listingReferData = false;
      })
      .addCase(listReferrals.rejected, (state, action) => {
        state.listingReferData = false;
        state.listingReferDataError = action.payload;
      })
      .addCase(getReferralEarning.pending, (state) => {
        state.fetchingEarning = true;
        state.fetchingEarningError = null;
      })
      .addCase(getReferralEarning.fulfilled, (state, action) => {
        state.referralEarning = action.payload;
        state.fetchingEarning = false;
      })
      .addCase(getReferralEarning.rejected, (state, action) => {
        state.fetchingEarning = false;
        state.fetchingEarningError = action.payload;
      })
      // Share Referral
      .addCase(shareReferral.pending, (state) => {
        state.sharingReferral = true;
        state.sharingReferralError = null;
      })
      .addCase(shareReferral.fulfilled, (state) => {
        state.sharingReferral = false;
      })
      .addCase(shareReferral.rejected, (state, action) => {
        state.sharingReferral = false;
        state.sharingReferralError = action.payload;
      });
  },
});

export default referralSlice.reducer;
